export default __webpack_public_path__ + "static/blob3-3a3733829007e274d375d50003f658e7.svg";